import moment from 'moment'
import { color } from 'styles/colors'
import _ from 'underscore'
import { replace } from 'helpers/formatters'
import { PremiumAdoption } from 'types/PremiumAdoption'

const MONTHLY = 'Monthly'
const YEARLY = 'Yearly'
const EXPIRED = 'Expired'
const FREE_TRIAL = 'Free Trial'

const LAYOUT: Partial<Plotly.Layout> = {
  margin: { t: 20, b: 20, l: 20, r: 25, pad: 0 },
  showlegend: false,
  autosize: true
}

const DATA: Plotly.Data = {
  type: 'pie',
  showlegend: false,
  textinfo: 'value',
  textposition: 'outside',
  texttemplate: '<b>%{value}</b>',
  outsidetextfont: {
    family: 'Inter',
    size: 15,
    color: color('thirdHeaderText')
  },
  values: [],
  labels: [],
  marker: {
    colors: []
  },
  hoverinfo: 'label+percent',
  hoverlabel: { bgcolor: color('paneBackground'), font: { color: color('tertiaryButtonHoverText'), size: 13, family: 'Inter' } },
  hovertemplate: '%{label}: ' + '<br>%{percent}<br>' + '<extra></extra>',
  automargin: false // Plotly lib issue. Throws Too many redraw issue if it sets to True.
}

const CONFIG: Partial<Plotly.Config> = {
  scrollZoom: false,
  displaylogo: false,
  autosizable: true,
  responsive: true,
  modeBarButtonsToRemove: ['toImage']
}

const filterPremiumDealers = (premiumDealers, variant, days) => {
  return _.filter(premiumDealers, premiumDealer => {
    const periodStartDate = moment().subtract(days, 'days')

    const premiumDealerStartDate = moment(premiumDealer.createdAt)

    if (variant === 'new') {
      return premiumDealerStartDate && premiumDealerStartDate.isSameOrAfter(periodStartDate)
    } else if (variant === 'existing') {
      return premiumDealerStartDate && premiumDealerStartDate.isBefore(periodStartDate)
    }
  })
}

const createPremiumDealerStatusBreakdown = (premiumDealers) => {
  const chartData: Array<{ name: string, y: number, amt: number, color: string }> = [
    { name: MONTHLY, y: 0, amt: 0, color: color(replace(`premiumAdoption${MONTHLY}`, ' ', '')) },
    { name: YEARLY, y: 0, amt: 0, color: color(replace(`premiumAdoption${YEARLY}`, ' ', '')) },
    { name: FREE_TRIAL, y: 0, amt: 0, color: color(replace(`premiumAdoption${FREE_TRIAL}`, ' ', '')) },
    { name: EXPIRED, y: 0, amt: 0, color: color(replace(`premiumAdoption${EXPIRED}`, ' ', '')) }
  ]
  let totalAmt: number = 0

  _.each(premiumDealers, (premiumDealer) => {
    if (isMonthly(premiumDealer)) {
      chartData[0].y += 1
    } else if (isYearly(premiumDealer)) {
      chartData[1].y += 1
    } else if (isTrial(premiumDealer)) {
      chartData[2].y += 1
    } else {
      chartData[3].y += 1
    }

    totalAmt += premiumDealer.planAmt
  })

  const filteredChartData = _.reject(chartData, (data) => data.y === 0)

  const data: Plotly.Data = {
    ...DATA,
    values: filteredChartData.map((data) => data.y),
    labels: filteredChartData.map((data) => data.name),
    marker: {
      colors: filteredChartData.map((data) => data.color)
    }
  }

  return { layout: LAYOUT, data, config: CONFIG, hasData: filteredChartData.length > 0, totalAmount: totalAmt }
}

const isMonthly = (premiumDealer: PremiumAdoption) => {
  if (premiumDealer.subscriptionPlan === 'monthly') {
    return true
  } else {
    return false
  }
}

const isYearly = (premiumDealer: PremiumAdoption) => {
  if (premiumDealer.subscriptionPlan === 'yearly') {
    return true
  } else {
    return false
  }
}

const isTrial = (premiumDealer: PremiumAdoption) => {
  if (premiumDealer.subscriptionPlan === 'trial') {
    return true
  } else {
    return false
  }
}

export const chartOptions = (variant: 'new' | 'existing', premiumDealers: Array<PremiumAdoption>, timeSpanInDays: number) => {
  return createPremiumDealerStatusBreakdown(filterPremiumDealers(premiumDealers, variant, timeSpanInDays))
}
